import React from "react";
import acceptSVG from "../resources/svg/accept-btn.svg";
import rejectSVG from "../resources/svg/reject-btn.svg";

const Confirm = ({ title, content, onConfirm, onReject }) => {
  return (
    <div className="confirm">
      <div className="content">{content}</div>
      <img
        src={acceptSVG}
        className="confirmOkBtn"
        alt="confirmOkBtn"
        role="button"
        tabIndex="0"
        onClick={() => {
          onConfirm();
        }}
        onKeyDown={(event) => {
          if (event.key === "Enter" || event.key === " ") onConfirm();
        }}
      />
      <img
        src={rejectSVG}
        className="confirmRejectBtn"
        alt="confirmRejectBtn"
        role="button"
        tabIndex="0"
        onClick={() => {
          onReject();
        }}
        onKeyDown={(event) => {
          if (event.key === "Enter" || event.key === " ") onReject();
        }}
      />
    </div>
  );
};

export default Confirm;
